import React from 'react';
import { TicketKey } from 'flow/types/EntityKeys';
import StatusOptionsItem from 'flow/components/tickets/ticket-info-section/options-section/StatusOptionsItem';
import AssigneeOptionsItem from 'flow/components/tickets/ticket-info-section/options-section/AssigneeOptionsItem';
import SubjectInput from 'flow/components/tickets/Input/SubjectInput';

interface Props {
    ticketKey: TicketKey;
}

const TicketOptionsSectionItem = ({ ticketKey }: Props) => {
    // Each control resolves the permission for the act it performs, as SubjectInput
    // below already did. One capability flag was standing in for two of them.
    return (
        <>
            <div className="flex flex-col gap-y-6">
                <AssigneeOptionsItem
                    ticketKey={ticketKey}
                    contextForSegment={'ticket details overview'}
                />
                <StatusOptionsItem
                    ticketKey={ticketKey}
                    contextForSegment={'ticket details overview'}
                />
                <SubjectInput ticketKey={ticketKey} />
            </div>
        </>
    );
};

export default React.memo(TicketOptionsSectionItem);
